import apiTamboUrl from "@/services/api";

function msgApiError(error, defaultMsg) {
  return error?.response?.data?.detail || error?.message || defaultMsg;
}

export default {
  namespaced: true,
  state: {
    movimientos: [],
    filtros: { categorias: [], usuarios: [] },
    detalleActual: null,
    loading: false,
    loadingDetalle: false,
    loadingRevertir: false,
    error: null,
  },
  getters: {
    movimientos: (s) => s.movimientos,
    filtros: (s) => s.filtros,
    detalleActual: (s) => s.detalleActual,
    loading: (s) => s.loading,
    loadingDetalle: (s) => s.loadingDetalle,
    loadingRevertir: (s) => s.loadingRevertir,
    error: (s) => s.error,
  },
  mutations: {
    setMovimientos(state, data) {
      state.movimientos = data;
    },
    setFiltros(state, data) {
      state.filtros = data;
    },
    setDetalleActual(state, data) {
      state.detalleActual = data;
    },
    setLoading(state, v) {
      state.loading = v;
    },
    setLoadingDetalle(state, v) {
      state.loadingDetalle = v;
    },
    setLoadingRevertir(state, v) {
      state.loadingRevertir = v;
    },
    setError(state, v) {
      state.error = v;
    },
    marcarRevertido(state, auditId) {
      const mov = state.movimientos.find((m) => m.id === auditId);
      if (mov) {
        mov.revertido = true;
        mov.puede_revertir = false;
      }
    },
    clearState(state) {
      state.movimientos = [];
      state.filtros = { categorias: [], usuarios: [] };
      state.detalleActual = null;
      state.error = null;
    },
  },
  actions: {
    async getMovimientos({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await apiTamboUrl.get("/auditoria/movimientos", {
          params,
        });
        commit("setMovimientos", data);
      } catch (e) {
        commit("setError", msgApiError(e, "Error al cargar movimientos"));
      } finally {
        commit("setLoading", false);
      }
    },

    async getFiltros({ commit }) {
      try {
        const { data } = await apiTamboUrl.get("/auditoria/filtros");
        commit("setFiltros", data);
      } catch (e) {
        console.error("Error cargando filtros de auditoría:", e);
      }
    },

    async getDetalle({ commit }, auditId) {
      commit("setLoadingDetalle", true);
      try {
        const { data } = await apiTamboUrl.get(
          `/auditoria/movimientos/${auditId}`
        );
        commit("setDetalleActual", data);
        return data;
      } catch (e) {
        commit("setError", msgApiError(e, "Error al cargar detalle"));
        return null;
      } finally {
        commit("setLoadingDetalle", false);
      }
    },

    async revertirMovimiento({ commit }, { auditId, motivo }) {
      commit("setLoadingRevertir", true);
      try {
        const { data } = await apiTamboUrl.post(
          `/auditoria/movimientos/${auditId}/revertir`,
          { motivo }
        );
        commit("marcarRevertido", auditId);
        return data;
      } catch (e) {
        throw new Error(msgApiError(e, "Error al revertir movimiento"));
      } finally {
        commit("setLoadingRevertir", false);
      }
    },
  },
};
